import React, { useCallback, useEffect, useMemo, useState } from 'react'
import OrderCorrectionItemsSection from './OrderCorrectionItemsSection'
import { InteractorCorrectionSearch } from '../../../interactors/Main'
// import { useSelector } from 'react-redux'
import { InputDatePicker, InputText } from '../../../components/Main'
import { useTranslation } from 'react-i18next'
import Validation, { titleMaxLength, titleMinLength } from '../../../constant/global/validation'
// import { confirmationAlert, showAlert } from '../../../utility/SweetAlert'
import { Link } from 'react-router-dom'

const OrderCorrectionView = () => {
  // const { account } = useSelector((state) => state.account)
  const { validationInputText } = Validation()
  // const { correctionCreate } = InteractorCorrectionCreate()
  const { t } = useTranslation()
  const pathSegments = window.location.pathname.split('/')
  const uid = pathSegments[pathSegments.length - 1]
  const [loading, setLoading] = useState(true)
  const [orderData, setOrderData] = useState({})
  const { correctionSearch } = InteractorCorrectionSearch()
  const [activeTab, setActiveTab] = useState('after')
  const [detailCorrection, setDetailCorrection] = useState({
    reference_number_internal: '',
    correction_note: '',
    purchase_order_number: '',
    store_name: '',
    initial_status: '',
    created_date: '',
    correction_approved_date: '',
  })
  const [correctionItemsAfter, setCorrectionItemsAfter] = useState([])
  const [correctionAfterTotal, setCorrectionAfterTotal] = useState({
    shippingCost: 0,
    shippingCostBilled: 0,
    insuranceCost: 0,
    insuranceCostBilled: 0,
    totalOrder: 0,
    totalPayment: 0,
    unappliedDownPayment: 0,
  })
  const [correctionItemsBefore, setCorrectionItemsBefore] = useState([])
  const [correctionBeforeTotal, setCorrectionBeforeTotal] = useState({
    shippingCost: 0,
    shippingCostBilled: 0,
    insuranceCost: 0,
    insuranceCostBilled: 0,
    totalOrder: 0,
    totalPayment: 0,
    unappliedDownPayment: 0,
  })
  const payloadCorrectionHeaderSearch = useMemo(
    () => ({
      page: 1,
      limit: 5,
      keywords: {
        uid,
      },
    }),
    [uid],
  )

  const [error, setError] = useState({
    reference_number_internal: null,
    correction_note: null,
    purchase_order_number: null,
    store_name: null,
    account_uid: null,
    initial_status: null,
    created_date: null,
    correction_approved_date: null,
  })

  const correction_status = [
    { value: '', label: t(`initial_status.CORRECTION_STATUS`), disabled: true },
    { value: 'REQUEST', label: t(`initial_status.WAITING_APPROVAL`) },
    { value: 'APPROVED', label: t(`initial_status.APPROVED`) },
    { value: 'CANCELLED', label: t(`initial_status.CANCELLED`) },
    { value: 'REJECTED', label: t(`initial_status.REJECTED_BY_SELLER`) },
  ]

  const handleCorrectionHeaderSearch = useCallback((response) => {
    if (response?.items) {
      const item_data = response.items[0]
      setDetailCorrection({
        reference_number_internal: item_data?.reference_number_internal || '',
        created_date: new Date(item_data?.created_date),
        correction_approved_date: new Date(item_data?.correction_approved_date),
        initial_status: item_data?.initial_status || '',
        store_name: item_data?.store_name || '',
        purchase_order_number: item_data?.purchase_order_number || '',
        correction_note: item_data?.correction_note || '',
      })
      const transactionItems = item_data?.correction_lines || []
      const before = []
      const after = []

      transactionItems.forEach((item) => {
        // collect before correction item
        if (item.lines_type !== 'ADDED') {
          before.push(item)
        }
        // collect after correction item
        if (item.lines_type !== 'REMOVED') {
          after.push(item)
        }
      })

      const corectionItemsBefore = before.map((item) => ({
        product_title: item.before_product_title,
        product_quantity: item.before_product_quantity,
        product_price: item.before_product_price,
        product_total_price: item.before_product_quantity * item.before_product_price,
        product_uid: item.before_product_uid,
        product_thumbnail: item.before_product_thumbnail,
        product_amount_allocated: item.product_total_down_payment_unapplied,
        product_already_paid: item.total_price_billed * item.total_quantity_billed,
        product_total_down_payment_unapplied: item.product_total_down_payment_unapplied || 0,
      }))
      const corectionItemsAfter = after.map((item) => ({
        product_title: item.after_product_title,
        product_quantity: item.after_product_quantity,
        product_price: item.after_product_price,
        product_total_price: item.after_product_quantity * item.after_product_price,
        product_uid: item.after_product_uid,
        product_thumbnail: item.after_product_thumbnail,
        product_amount_allocated: item.product_amount_allocated,
        product_already_paid: item.total_price_billed * item.total_quantity_billed,
        product_total_down_payment_unapplied: item.product_total_down_payment_unapplied || 0,
      }))

      setCorrectionItemsBefore(corectionItemsBefore)
      setCorrectionItemsAfter(corectionItemsAfter)
      setOrderData(item_data)

      // Calculate total price
      const totalOrderBefore = corectionItemsBefore?.reduce(
        (sum, item) => sum + item.product_total_price,
        0,
      )
      const totalOrderAfter = corectionItemsAfter?.reduce(
        (sum, item) => sum + item.product_total_price,
        0,
      )
      // const totalUnappliedBefore = corectionItemsBefore.reduce(
      //   (sum, item) => sum + (Number(item.product_total_down_payment_unapplied) || 0),
      //   0,
      // )
      // const totalUnappliedAfter = corectionItemsAfter.reduce(
      //   (sum, item) => sum + (Number(item.product_total_down_payment_unapplied) || 0),
      //   0,
      // )
      // You can adjust shippingCost, insuranceCost, and totalPayment as needed
      setCorrectionBeforeTotal({
        shippingCost: item_data?.delivery_cost_before || 0,
        shippingCostBilled: item_data?.delivery_cost_billed || 0,
        insuranceCost: item_data?.delivery_insurance_cost_before || 0,
        insuranceCostBilled: item_data?.delivery_insurance_cost_billed || 0,
        totalOrder: totalOrderBefore,
        totalPayment:
          totalOrderBefore +
          (item_data?.delivery_cost_before || 0) +
          (item_data?.delivery_insurance_cost_before || 0),
      })
      setCorrectionAfterTotal({
        shippingCost: item_data?.delivery_cost_after || 0,
        shippingCostBilled: item_data?.delivery_cost_billed || 0,
        insuranceCost: item_data?.delivery_insurance_cost_after || 0,
        insuranceCostBilled: item_data?.delivery_insurance_cost_billed || 0,
        totalOrder: totalOrderAfter,
        totalPayment:
          totalOrderAfter +
          (item_data?.delivery_cost_after || 0) +
          (item_data?.delivery_insurance_cost_after || 0),
      })
    }
  }, [])

  useEffect(() => {
    if (loading) {
      correctionSearch(payloadCorrectionHeaderSearch, handleCorrectionHeaderSearch, setLoading)
    }
  }, [handleCorrectionHeaderSearch, correctionSearch, payloadCorrectionHeaderSearch, loading])

  // const parsingItems = () => {
  //   const correctionItems = []
  //   let sort = 1

  //   const afterMap = {}
  //   correctionItemsAfter.forEach((item) => {
  //     afterMap[item.product_uid] = item
  //   })

  //   correctionItemsBefore.forEach((beforeItem) => {
  //     const afterItem = afterMap[beforeItem.product_uid]

  //     correctionItems.push({
  //       product_title: beforeItem.product_title,
  //       transaction_uid: uid,
  //       transaction_item_uid: `item-uid-${sort}`,
  //       lines_type: afterItem ? 'CHANGED' : 'REMOVED',
  //       before_product_uid: beforeItem.product_uid,
  //       before_product_unit_type: beforeItem.product_unit_type,
  //       before_product_quantity: beforeItem.product_quantity,
  //       before_product_price: beforeItem.product_price,
  //       after_product_uid: afterItem.product_uid,
  //       after_product_unit_type: afterItem?.product_unit_type,
  //       after_product_quantity: afterItem?.product_quantity,
  //       after_product_price: afterItem?.product_price,
  //       sort_number: sort++,
  //     })
  //   })

  //   const beforeUids = correctionItemsBefore.map((item) => item.product_uid)

  //   correctionItemsAfter.forEach((afterItem) => {
  //     if (!beforeUids.includes(afterItem.product_uid)) {
  //       correctionItems.push({
  //         product_title: afterItem.product_title,
  //         transaction_uid: uid,
  //         transaction_item_uid: `item-uid-${sort}`,
  //         lines_type: 'ADDED',
  //         before_product_uid: afterItem.product_uid,
  //         before_product_unit_type: '',
  //         before_product_quantity: 0,
  //         before_product_price: 0,
  //         after_product_uid: afterItem.product_uid,
  //         after_product_unit_type: afterItem.product_unit_type || '',
  //         after_product_quantity: afterItem.product_quantity,
  //         after_product_price: afterItem.product_price,
  //         sort_number: sort++,
  //       })
  //     }
  //   })

  //   return correctionItems
  // }

  // const handleSubmit = async (e) => {
  //   e.preventDefault()

  //   const correctionItems = parsingItems()

  //   const payload = {
  //     created_by: account?.full_name,
  //     transaction_uid: uid,
  //     transaction_code: orderData?.transaction_code,
  //     reference_number_internal: detailCorrection?.reference_number_internal,
  //     customer_account_uid: orderData?.customer_account_uid,
  //     customer_company_uid: orderData?.customer_company_uid,
  //     store_uid: orderData?.store_uid,
  //     delivery_cost_before: correctionBeforeTotal?.shippingCost,
  //     delivery_cost_after: correctionAfterTotal?.shippingCost,
  //     delivery_insurance_cost_before: correctionBeforeTotal?.insuranceCost,
  //     delivery_insurance_cost_after: correctionAfterTotal?.insuranceCost,
  //     payment_tax_amount_before: 0,
  //     payment_tax_amount_after: 0,
  //     payment_additional_before: 0,
  //     payment_additional_after: 0,
  //     payment_amount_before: correctionBeforeTotal?.totalPayment,
  //     payment_amount_after: correctionAfterTotal?.totalPayment,
  //     correction_note: detailCorrection?.correction_note,
  //     correction_lines: correctionItems,
  //   }

  //   if (correctionItemsBefore.length < 1 || correctionItemsAfter.length < 1) {
  //     showAlert({
  //       icon: 'error',
  //       message: t('message.no_items_correction'),
  //       reload: false,
  //       timer: 3000,
  //     })
  //     return
  //   }

  //   if (
  //     error.reference_number_internal ||
  //     error.correction_approved_date ||
  //     error.created_date ||
  //     error.intial_status ||
  //     error.store_name
  //   ) {
  //     showAlert({
  //       icon: 'error',
  //       message: t('message.invalid_correction_submit'),
  //       reload: false,
  //       timer: 3000,
  //     })
  //     return
  //   }

  //   const confirm = await confirmationAlert({
  //     title: t('title.are_you_sure'),
  //     message: t('message.confirmation_purchase_order_number'),
  //     icon: 'warning',
  //   })
  //   if (confirm) {
  //     correctionCreate(payload, setLoading, true)
  //   }

  //   setLoading(true)
  // }

  const handlerInput = (e) => {
    const { name, value } = e.target

    let message = validationInputText(value, titleMinLength, titleMaxLength, t(`form.${name}`))
    setError((prev) => ({ ...prev, [name]: message }))

    setDetailCorrection({
      ...detailCorrection,
      [name]: value,
    })
  }

  const datePickHandler = (value) => {
    setDetailCorrection({
      ...detailCorrection,
      created_date: value,
    })
  }

  const handlerCorrectionStatus = (e) => {
    const { name, value } = e.target
    if (value.length === 0) {
      setError({
        ...error,
        [name]: value,
      })
      return
    }
    setDetailCorrection({
      ...detailCorrection,
      [name]: value,
    })
    setError((prev) => ({ ...prev, [name]: null }))
  }

  const isValidDate = (d) => d instanceof Date && !isNaN(d.getTime())

  return (
    <div className="container py-4">
      {/* Header */}
      <div className="d-flex justify-content-between mb-3">
        <h6 className="text-primary fw-bold">
          {t('form.correction_main_title')} - {orderData?.transaction_code}
        </h6>
        <Link
          to={'#'}
          onClick={() => {
            window.location = `/order/correction/${orderData.transaction_uid}`
          }}
          className="text-dark btn-outline-secondary btn btn-xs m-2 font-size-12"
        >
          <i className="fas fa-arrow-left px-2"></i> {t('button.back')}
        </Link>
      </div>
      <div className="card p-3 mb-4">
        <div className="row g-3">
          <div className="col-md-6 pb-2 pt-1">
            <InputText
              label={t('form.reference_number_internal')}
              value={detailCorrection?.reference_number_internal || ''}
              onChange={handlerInput}
              error={!!error.reference_number_internal}
              errorMsg={error.reference_number_internal}
              name="reference_number_internal"
              disable={true}
            />
          </div>
          <div className="col-md-6 pb-2">
            <label className="font-size-12 font-weight-bold">{t('form.created_date')}</label>
            <InputDatePicker
              key={
                isValidDate(detailCorrection?.created_date)
                  ? detailCorrection?.created_date.toISOString()
                  : 'created-date'
              }
              initial="DDMMYY"
              required={false}
              changeYear={true}
              onCallback={datePickHandler}
              startDate={detailCorrection?.created_date}
              disabled={true}
            />
          </div>
          <div className="col-md-6 pb-2 pt-1">
            <label className="font-size-12 font-weight-bold">
              {t('form.correction_approved_date')}
            </label>
            <InputDatePicker
              key={
                isValidDate(detailCorrection?.correction_approved_date)
                  ? detailCorrection?.correction_approved_date.toISOString()
                  : 'correction-approved-date'
              }
              initial="DDMMYY"
              required={false}
              changeYear={true}
              onCallback={datePickHandler}
              startDate={detailCorrection?.correction_approved_date}
              disabled={true}
            />
          </div>
          <div className="col-md-6 pb-2 pt-1">
            <label className="font-size-12 font-weight-bold">{t('title.status')}</label>
            <select
              className={`form-control ${
                error.initial_status ? 'border border-danger text-danger' : ''
              }`}
              name="initial_status"
              value={detailCorrection?.initial_status}
              onChange={handlerCorrectionStatus}
              disabled
            >
              {correction_status?.map((item, index) => {
                return (
                  <option key={index} value={item.value} disabled={item.disabled}>
                    {item.label}
                  </option>
                )
              })}
            </select>
          </div>
          <div className="col-md-6 pb-2 pt-1">
            <InputText
              label={t('form.store_name')}
              value={detailCorrection?.store_name || ''}
              onChange={handlerInput}
              error={!!error.store_name}
              errorMsg={error.store_name}
              name="store_name"
              disable={true}
            />
          </div>
          <div className="col-md-6 pb-2 pt-1">
            <InputText
              label={t('form.purchase_order_number')}
              value={detailCorrection?.purchase_order_number || ''}
              onChange={handlerInput}
              error={!!error.purchase_order_number}
              errorMsg={error.purchase_order_number}
              name="purchase_order_number"
              disable={true}
            />
          </div>
          <div className="col-12 pb-2 pt-1">
            <InputText
              label={t('form.correction_note')}
              value={detailCorrection?.correction_note || ''}
              onChange={handlerInput}
              error={!!error.correction_note}
              errorMsg={error.correction_note}
              name="correction_note"
              disable={true}
            />
          </div>
        </div>
      </div>

      {/* Tab Section */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'after' ? 'active' : ''}`}
            onClick={() => setActiveTab('after')}
          >
            {t('title.after')}
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'before' ? 'active' : ''}`}
            onClick={() => setActiveTab('before')}
          >
            {t('title.before')}
          </button>
        </li>
      </ul>

      {activeTab === 'after' && (
        <OrderCorrectionItemsSection
          label={t('form.correction_product_after')}
          orderData={orderData}
          items={correctionItemsAfter}
          setItems={setCorrectionItemsAfter}
          totalData={correctionAfterTotal}
          setTotalData={setCorrectionAfterTotal}
        />
      )}
      {activeTab === 'before' && (
        <OrderCorrectionItemsSection
          label={t('form.correction_product_before')}
          orderData={orderData}
          items={correctionItemsBefore}
          setItems={setCorrectionItemsBefore}
          totalData={correctionBeforeTotal}
          setTotalData={setCorrectionBeforeTotal}
        />
      )}

      {/* <div className="text-center mt-4">
        <button className="btn btn-primary px-4" onClick={handleSubmit}>
          Simpan
        </button>
      </div> */}
    </div>
  )
}

export default OrderCorrectionView
